module.exports = __webpack_public_path__ + "img/profilIcon.11c51171.png";